import React, { useEffect, useRef } from 'react';
import Message from './Message';
import './ChatBox.css';
import LoadingIndicator from './LoadingIndicator';

const ChatBox = ({ messages, loading }) => {
  const chatBoxRef = useRef(null);

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="ChatBox" ref={chatBoxRef}>
      {messages.map((message, index) => (
        <Message key={index} parts={message.parts} sender={message.sender} />
      ))}
      {loading && <LoadingIndicator />}
    </div>
  );
};

export default ChatBox;
